import { put, takeLatest } from "redux-saga/effects";
import { getValidateLoginFaceIdApi } from "store/api/LoginApi";
import { GET_VALIDATE_LOGIN_FACE_ID_ACTION } from "../../actions/GlobalAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getValidateLoginFaceId() {
	const res = yield getValidateLoginFaceIdApi();
	try {
		if (res?.code === 0) {
			yield put(
				globalAction.setValidateLoginFaceIdAction(
					res?.data?.isLoginFaceId || false
				)
			);
		} else {
			yield showMessage(true, res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getValidateLoginFaceIdSaga() {
	yield takeLatest(GET_VALIDATE_LOGIN_FACE_ID_ACTION, getValidateLoginFaceId);
}

export default getValidateLoginFaceIdSaga;
